import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useEditIncentivesMarketTermsAndConditionsTemplateModal } from '../context/EditIncentivesMarketTermsAndConditionsTemplateModalContext';

const EditIncentivesMarketTermsAndConditionsTemplateModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } =
    useEditIncentivesMarketTermsAndConditionsTemplateModal();

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-light"
          onClick={actions.handleCloseModal}
          disabled={data.isSaving}
        >
          {t('Cancel')}
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={actions.handleSave}
          disabled={data.isSaving || data.loadError || !data.documentId}
        >
          {t('Save')}
        </button>
      </Modal.Footer>
      {data.isSaving && <CustomLoading />}
    </>
  );
};

export default EditIncentivesMarketTermsAndConditionsTemplateModalFooter;
